import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  id: "chart-indicators",
  class: "evolution-chart-line-chart-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "left-indicator",
  class: "indicator"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "right-indicator",
  class: "indicator"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Line = _resolveComponent("Line");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.showEvolution ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "x2-label",
    style: _normalizeStyle({
      ['--metric-color']: $props.metricColor
    })
  }, [_hoisted_2, _createTextVNode(" " + _toDisplayString($props.x2Label), 1)], 4)) : _createCommentVNode("", true), _hoisted_3, _createVNode(_component_Line, {
    ref: "chart",
    data: $props.data,
    options: $options.mergedOptions
  }, null, 8, ["data", "options"]), _hoisted_4]);
}